import { CheckInviteTokenResp_Invitation } from '@/shared/api/protocol-ts/api/auth/svc_authentication_pb';

import { CurrentUserIdentity } from '../config';

const normalizeEmail = (email: string) => email.trim().toLowerCase();

const getRecipient = (invitation: CheckInviteTokenResp_Invitation) => {
  if (invitation.Result.case === 'OrganizationStaff') {
    return {
      userID: invitation.Result.value.UserID,
      email: invitation.Result.value.PersonalData?.Email,
    };
  }

  if (invitation.Result.case === 'Sharing') {
    return {
      userID: invitation.Result.value.Recipient?.UserID,
      email: invitation.Result.value.Recipient?.Email,
    };
  }

  return { userID: undefined, email: undefined };
};

/**
 * NOTE: an invitation to a not-yet-registered person carries no `UserID`, so the
 * email is the only identity available in that case. When neither is known the
 * answer is `true`: an unverifiable invitation must never drop the session.
 */
export const isInvitationAddressedToCurrentUser = (
  invitation: CheckInviteTokenResp_Invitation,
  currentUser: CurrentUserIdentity,
): boolean => {
  const { userID, email } = getRecipient(invitation);

  if (userID) {
    return userID === currentUser.id;
  }

  if (email) {
    return currentUser.emails.some(
      (currentUserEmail) =>
        normalizeEmail(currentUserEmail) === normalizeEmail(email),
    );
  }

  return true;
};
